import { TeachersList } from 'presentation/app/modules/Professionals/Teachers/pages/teachers-list';
import React from 'react';

export const MakeTeachersList: React.FC = () => {
  return <TeachersList />;
};
